import React from 'react'
import { Pane, Text } from "evergreen-ui";
import { FaRegMoneyBillAlt } from 'react-icons/fa'
import { useStatusContent } from '../../../config/roundContent'

const StatusRegister_0 = ({ DataRegister }) => {
    const row = DataRegister?.[0] || {}
    const { statusContent } = useStatusContent(row.ROB_ID, "0")
    const title = statusContent.titleText || 'อยู่ระหว่างการชำระค่าสมัคร'

    return (
        <Pane
            color="#fff"
            backgroundColor="#d6af00ff"
            height="100%"
            paddingY={4}
            paddingX={5}
            fontSize={14}
            margin={0}
            fontWeight={700}
            justifyContent="center"
            alignItems="center"
            display="flex"
            flexDirection="column"
        >
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <FaRegMoneyBillAlt /> &nbsp; {title}
            </div>
            {statusContent.bodyText ? (
                <Text color="#fff" fontSize={12} marginTop={4}>{statusContent.bodyText}</Text>
            ) : null}
        </Pane>
    )
}

export default StatusRegister_0
